import { useConfirmationDialog } from '@goodfynd/ui';
import { useSubscriptionApi } from '@hooks/api/account/useSubscriptionApi/useSubscriptionApi';
import { usePostApi } from '@hooks/api/usePostApi';
import type {
  ActiveSubscriptionItem,
  SaasProduct,
  SubscriptionCreate,
} from 'types/account/subscriptions';
import type { PostApiOptions } from 'types/api';

export function useCreateSubscription(
  organizationId: string,
  options?: Partial<PostApiOptions<ActiveSubscriptionItem, SubscriptionCreate>>
) {
  const api = useSubscriptionApi();
  const { getConfirmation } = useConfirmationDialog();

  const { post: createSubscription, isPosting: isCreatingSubscription } =
    usePostApi({
      getSuccessMessage: () => 'New subscription created',
      request: (params) => api.createSubscription(organizationId, params),
      ...options,
    });

  return {
    isCreatingSubscription,
    createSubscription: async (
      item: SaasProduct,
      priceId: string,
      paymentMethodId: string
    ) => {
      if (
        !(await getConfirmation({
          title: 'Add subscription',
          message: `Are you sure you want to buy the ${item.name}?`,
          confirmButtonText: 'Update',
        }))
      ) {
        return;
      }

      return createSubscription({
        paymentMethodId,
        priceId,
      });
    },
  };
}
